import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { IconSize, iconsMap, IconsName } from "@/utils/icons";
import { computed } from "vue";

export default /*#__PURE__*/_defineComponent({
  props: {
    name: null,
    size: null
  },
  setup(__props: any) {

const props = __props as {
  name?: keyof typeof IconsName;
  size?: IconSize;
}



const SvgIcon = computed(() => iconsMap[props.name || "piano"]);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(["icon inline-block", {
      ['w-12 md:w-24']: __props.size === 'xl',
      ['w-8 md:w-12 lg:w-16']: __props.size === 'l',
      ['w-6 md:w-10']: __props.size === 'm',
      ['w-4 md:w-6']: __props.size === 's' || !__props.size,
    }])
  }, [
    _createVNode(_unref(SvgIcon))
  ], 2))
}
}

})